import React, { useState } from "react";
import { Grid, } from "@mui/material";
import { Icon } from "@iconify/react";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import { Box, Chip, Tooltip, Typography, Modal } from '@mui/material';
import CountryDeleteModal from "./deleteModal";

export default function CountryManagementColum(props) {
  const navigate = useNavigate();
  const { setAlert, setOpenAlert, setResponseMsg, setLoading, getCountryData } = props;
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const ALERT_DURATION = 2000;
  const alertClose = () => {
    setAlert('')
  }
  const handleOpenDeleteModal = (id, status) => {
    setSelectedId(id);
    setSelectedStatus(status);
    setOpenDeleteModal(true);
  };


  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };


  const countryMangeMentColumn = [
    // {
    //   field: 'id',
    //   headerName: 'ID',
    // },
    {
      field: 'countryName',
      headerName: 'Country',
      flex: 1,
      renderCell: (params) => (
        <Grid onClick={() => navigate(`/countryManagementView/${params.row.id}?type=edit`)}>
          <span style={{ color: "darkblue", cursor: "pointer" }}>{params.value}</span>
        </Grid>
      ),
    },
    {
      field: 'regionName',
      headerName: 'Region',
      flex: 1,
    },
    {
      field: 'solutions',
      headerName: 'Solutions',
      flex: 1,
      renderCell: (params) => {
        const solutions = params.row.countrySolution;

        if (!solutions || solutions.length === 0) {
          return <Typography>-</Typography>;
        }

        const firstType = solutions[0];
        const remainingTypes = solutions.slice(1);

        const tooltipContent = (
          <Box display="flex" flexWrap="wrap" gap={1}>
            {remainingTypes.map((type, index) => (
              <Chip
                key={index}
                label={type.name}
                variant="outlined"
                sx={{
                  borderColor: 'var(--primary-color)',
                  color: 'var(--primary-color)',
                  backgroundColor: 'var(--white-color)',
                  fontWeight: 900,
                  borderRadius: '16px',
                  height: 32,
                }}
              />
            ))}
          </Box>
        );

        return (
          <Box display="flex" gap={1} alignItems="center" style={{ paddingTop: 10 }}>
            <Chip
              label={firstType.name}
              variant="outlined"
              sx={{
                borderColor: 'var(--primary-color)',
                color: 'var(--primary-color)',
                backgroundColor: 'var(--white-color)',
                fontWeight: 900,
                borderRadius: '16px',
                height: 32,
              }}
            />
            {remainingTypes.length > 0 && (
              <Tooltip title={tooltipContent} placement="top-start" arrow>
                <Typography
                  sx={{
                    fontSize: 14,
                    color: 'var(--primary-color)',
                    cursor: 'pointer',
                    textDecoration: 'underline dotted',
                  }}
                >
                  +{remainingTypes.length} more
                </Typography>
              </Tooltip>
            )}
          </Box>
        );
      },
    },
    {
      field: 'currency',
      headerName: 'Currency',
      flex: 1,
    },
    {
      field: 'timezone',
      headerName: 'Timezone',
      flex: 1,
    },
    {
      field: 'createdAt',
      headerName: 'Added On',
      flex: 1,
      renderCell: (params) => {
        const dateOnly = params.value ? new Date(params.value).toISOString().split('T')[0] : '';
        return (
          <Grid>
            <span>{dateOnly}</span>
          </Grid>
        );
      },
    },    
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <>
          <Grid>
            <IconButton aria-label="edit" size="small">
              <img src="/assets/editIcon.svg" alt="District" width="16" height="16"  onClick={() => navigate(`/countryManagementCreation/${params.row.id}?type=edit`)}/>
            </IconButton>

            <IconButton aria-label="delete" size="small" onClick={() => handleOpenDeleteModal(params.row.id)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="red" d="M7.5 1h9v3H22v2h-2.029l-.5 17H4.529l-.5-17H2V4h5.5zm2 3h5V3h-5zM6.03 6l.441 15h11.058l.441-15zM13 8v11h-2V8z" /></svg>
            </IconButton>
          </Grid>

          <Modal open={openDeleteModal} onClose={handleCloseDeleteModal} BackdropProps={{ sx: { backgroundColor: "rgba(0, 0, 0, 0.1)" } }} >
            <CountryDeleteModal onClose={handleCloseDeleteModal} getCountryData={getCountryData} selectedId={selectedId} selectedStatus={selectedStatus} alertClose={alertClose} setOpenAlert={setOpenAlert} setResponseMsg={setResponseMsg} setAlert={setAlert} ALERT_DURATION={ALERT_DURATION} setLoading={setLoading} />
          </Modal>
        </>
      ),
    },

  ];

  return countryMangeMentColumn;
}
